import React from "react";
import Button from "@mui/material/Button";
import SaveIcon from "@mui/icons-material/SaveOutlined";
import "../../../styles/button.scss"


const SaveButton = ({label='', onClick = () => {}, style= {}}) => {

    return <Button variant={"outlined"} className={"center-right mobileButton"} style={style} onClick={onClick}>
        {label}
        <SaveIcon />
    </Button>
}

export default SaveButton
